import axios from 'axios';
import { getToken } from '../util/jwtToken';

const BASE_URL = process.env.REACT_APP_BASE_URL;
const apiClient = axios.create({ baseURL: `${BASE_URL}` });

export const login = async (data) => {
  try {
    const formData = new FormData();
    formData.append('username', data.username);
    formData.append('password', data.password);

    const response = await apiClient.post('/login', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (e) {
    throw new Error(e);
  }
};

export const getProducts = async () => {
  try {
    const token = getToken();

    const response = await apiClient.get('/products', {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (e) {
    throw { status: e?.response?.status || 500, message: e?.message || 'Unknown error' };
  }
};

export const getProduct = async (mpn) => {
  try {
    const token = getToken();

    const response = await apiClient.get(`/variations/${mpn}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (e) {
    throw { status: e?.response?.status || 500, message: e?.message || 'Unknown error' };
  }
};

export const getStockLimit = async () => {
  try {
    const token = getToken();

    const response = await apiClient.get('/stock-limit', {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (e) {
    throw { status: e?.response?.status || 500, message: e?.message || 'Unknown error' };
  }
};

export const updateStockLimit = async (limit) => {
  try {
    const token = getToken();

    const response = await apiClient.patch(`/stock-limit?limit=${limit}`, null, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (e) {
    throw { status: e?.response?.status || 500, message: e?.message || 'Unknown error' };
  }
};

export const updateVariant = async (mpn, data) => {
  try {
    const token = getToken();

    const response = await apiClient.patch(`/variations/${mpn}`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data;
  } catch (e) {
    throw new Error(e);
  }
};
